<div class="order-table">

  <div class="table-container">
    <div class="table-over-header">
      <div class="text-title border-bottom padding-inside">
        <span class="subtitle">OrderId:</span> {{order.id}}
      </div>
      @if(order.afterPaymentKey==="MEMBERSHIP") {
        <div class="border-bottom padding-inside line">
          <span class="subtitle">Related to:</span> Membership id: {{order.reference}}
        </div>
      }
      @if(order.specialSection==="DONATION") {
        <div class="border-bottom padding-inside line">
          <span class="subtitle">Related to:</span> Donation
        </div>
      }
      <div class="border-bottom padding-inside line">
        <span class="subtitle">Created:</span> {{order.created | timestamp | date:'medium' }}
      </div>
      @if(order.status==="PAID") {
        <div class="border-bottom padding-inside line">
          <span class="subtitle">Paid:</span> {{order.paid || 0 | timestamp | date:'medium' }}
        </div>
      }
    </div>

    <equine-ui-nx-order-detail-table
      [details]="order.details"
    ></equine-ui-nx-order-detail-table>

    <table mat-table [dataSource]="order.purchaseItems">

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Description </th>
        <td mat-cell *matCellDef="let line"> {{line.description}} </td>
      </ng-container>
    
      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef> Quantity </th>
        <td mat-cell *matCellDef="let line"> {{line.quantity}} </td>
      </ng-container>
    
      <ng-container matColumnDef="unitAmount">
        <th mat-header-cell *matHeaderCellDef> Unit Amount </th>
        <td mat-cell *matCellDef="let line"> {{line.unitAmount | amount | currency }} </td>
      </ng-container>
    
      <!-- Symbol Column -->
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef> Total </th>
        <td mat-cell *matCellDef="let line"> {{line.quantity * line.unitAmount | amount | currency }} </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div class="total-section">
      Total: {{ order.total || 0 | amount | currency }}
    </div>

  </div>

  


</div>